module.exports = __webpack_public_path__ + "img/banco-original.d502fe37.svg";